import { FC } from 'react';
import { CellData } from '../Calendar/DayCell/DayCell';
import { IService } from 'interfaces/services';
import { SyncExceptionShift } from 'interfaces/serviceScheduleException';
import DefaultModal from 'components/Modals/DefaultModal';
import { DATE_TIME_FORMAT } from 'utils/datetime';
import moment from 'moment';
import CommonButton from 'components/CommonButton/CommonButton';
import useModal from 'hooks/useModal';
import { groupBy, sortBy } from 'lodash';

interface SyncExceptionModalSelectedCellData extends Omit<CellData, 'shifts'> {
  shifts: SyncExceptionShift[];
}

interface SyncExceptionModalProps {
  selectedCellData: SyncExceptionModalSelectedCellData;
  service: IService;
  onClose: () => void;
}

const SyncExceptionModal: FC<SyncExceptionModalProps> = ({
  selectedCellData,
  onClose,
}) => {
  useModal({ onClose });
  const renderType = () => {
    if (selectedCellData.isClinicClosed) {
      return 'Office Closed';
    } else if (selectedCellData.isServiceClosed) {
      return 'Unavailable';
    }

    return 'Working Day';
  };

  const renderWorkingHours = () => {
    if (Array.isArray(selectedCellData.shifts)) {
      const groupByOpId = groupBy(selectedCellData.shifts, 'operatory.id');

      return Object.keys(groupByOpId).map((operatoryId) => {
        const workingHours = groupByOpId[operatoryId];

        const sortedByStartTime = sortBy(workingHours, (item) =>
          moment(item.startTime, DATE_TIME_FORMAT.HH_MM_SS).valueOf()
        );

        return (
          <div className="flex mt-1.5 ">
            <span className="text-13 leading-[2rem] w-full max-w-[180px] text-dim-grey font-bold">
              {groupByOpId[operatoryId]?.[0]?.operatory.name || ''}
            </span>
            <div className="ml-5">
              {sortedByStartTime.map((item) => {
                const startTime = moment(item.startTime, 'HH:mm:ss').format(
                  'hh:mmA'
                );

                const endTime = moment(item.endTime, 'HH:mm:ss').format(
                  'hh:mmA'
                );

                return (
                  <div className="mb-[4px]">{`${startTime}-${endTime}`}</div>
                );
              })}
            </div>
          </div>
        );
      });
    }
  };

  return (
    <DefaultModal className="top-[45%]">
      <div className="w-[480px] min-h-[290px] p-2 text-14 leading-[2.1rem] text-darkest-grey relative flex flex-col">
        <h3 className="text-16 leading-[2.4rem] font-bold">
          PMS Blockout Type Availability
        </h3>
        <div className="flex items-center mt-1.5 ">
          <span className="text-13 leading-[2rem] w-full max-w-[180px] text-dim-grey font-bold">
            Type
          </span>
          <div className="flex-1 w-full ml-5">{renderType()}</div>
        </div>

        <div className="flex items-center mt-1.5 ">
          <span className="text-13 leading-[2rem] w-full max-w-[180px] text-dim-grey font-bold">
            Date
          </span>
          <div className="flex-1 w-full ml-5">
            {moment(
              selectedCellData.date,
              DATE_TIME_FORMAT.APPOINTMENT_DATE
            ).format('MMMM DD, YYYY')}
          </div>
        </div>
        {renderWorkingHours()}

        <div className="flex gap-x-1.6 justify-end mt-auto pt-[28px]">
          <CommonButton
            variant="secondary"
            className="!min-w-[13rem] !min-h-[3.2rem]"
            onClick={onClose}
          >
            Cancel
          </CommonButton>
        </div>
      </div>
    </DefaultModal>
  );
};

export default SyncExceptionModal;
